<template>

<div class="container-fluid">
    <div class="row">
        <div class="col">
            <!-- native file input for file click -->
            <label 
                ref="drop"
                class="kt-upload form-control text-center p-5"
                @dragenter="dragEnter"
                @dragover="dragOver"
                @dragleave="dragLeave"
                @drop="dragDrop"
            >
                <span>Drag &amp; Drop your files or <u>Browse</u></span>
                <input
                    :id="props.id"
                    ref="upload"
                    class="kt-upload"
                    type="file"
                    @change="change"
                    :multiple="props.multiple"
                />
            </label>
        </div>
    </div>
</div>

</template>

<script setup>

import { ref, onMounted } from "vue";

const upload = ref(null);
const drop = ref(null);

const props = defineProps({
    id: 
    {
        type: String,
        default() 
        {
            return "upload-" + (Math.random() + "").substring(2);
        }
    },
    multiple: {
        type: Boolean,
        default: false
    }
});

const emits = defineEmits([
    "process"
]);

const dragEnter = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "#e1e1e1";
};

const dragOver = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "#e1e1e1";
};

const dragLeave = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "transparent";
};

const dragDrop = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    drop.value.style.background = "transparent";
    const files = e.dataTransfer.files;
    
    // Process files here
    emits("process", files);
}

const change = (e) =>
{
    if (upload.value.files.length)
    {
        emits("process", upload.value.files);
    }
};

onMounted(() =>
{
    // ... nothing   
});

</script>

<style scoped>

.kt-upload {
    border: 1px dotted #dedede;

}

.kt-upload input {
    position: absolute;
    visibility: hidden;
}
    

</style>